import React, { useState, useEffect } from "react";
import useQuestionaire from "../../hooks/useQuestionaire";
import useUser from "../../../../customHooks/useUser";
import ThankYou from "../CorporateOnboardingStepper/components/ThankYou";

function _renderStepContent(step) {
  switch (step) {
    case 0:
      return <ThankYou />;
    default:
      return;
  }
}

const DeveloperOnboardingStepper = ({ activeStep, setActiveStep }) => {
  const isLastStep = activeStep === 0;
  const [send, setSend] = useState(false);
  const { createQuestionnaireForUserType, selectedUserType, userTypes } =
    useQuestionaire();
  const { csrfToken } = useUser();

  useEffect(() => {
    if (isLastStep && userTypes && userTypes.length > 0 && csrfToken) {
      if (!send) {
        setTimeout(() => {
          createQuestionnaireForUserType("DEVELOPER", {
            field_product_categories: [],
            title: `Questionnaire for freelancer developer`,
          });
        }, 3000);
        setSend(true);
      }
    }
  }, [isLastStep, createQuestionnaireForUserType, userTypes, csrfToken]);

  return (
    <div className="stepper-form-container">
      {_renderStepContent(activeStep)}
    </div>
  );
};

export default DeveloperOnboardingStepper;
